export class BookingTableOracle {
    constructor() {
    }

    showResponse(response){
        this.bookingTableDiv().innerHTML = response;
    }

    hide(){
        this.bookingTableDiv().style.display = 'none';
    }

    show(){
        this.bookingTableDiv().style.display = 'block';
    }

    bookingTableDiv(){
        return document.querySelector('#rez_rezerwacje_div');
    }
}